import barba from "@barba/core";
import tippy from "tippy.js";

const initErrorAudio = () => {
	const playButton = document.querySelector(
		".error-container__play-button:not(.is-initialized)"
	);

	if (playButton) {
		const audio = document.querySelector("#errorAudio");

		playButton.classList.add("is-initialized");

		function toggleAudio() {
			audio.paused ? audio.play() : audio.pause();
			playButton.classList.toggle("is-playing");
		}

		if (playButton) {
			playButton.addEventListener("click", () => {
				toggleAudio();
			});

			const errorAudioTippy = tippy(playButton, {
				content: wkScriptVars.tip_play,
				allowHTML: true,
				placement: "bottom",
				showOnCreate: true,
				hideOnClick: false,
				trigger: "manual",
				delay: 1000,
			});

			document.addEventListener("headerOverlayOpened", () => {
				errorAudioTippy.hide();
			});
			document.addEventListener("headerOverlayClosed", () => {
				errorAudioTippy.show();
			});

			barba.hooks.beforeLeave(() => {
				errorAudioTippy.destroy();
			});
		}
	}
};

barba.hooks.beforeEnter(initErrorAudio);
document.addEventListener("DOMContentLoaded", initErrorAudio);
